module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0107.jpg?v=dbfad83f";